import { backendPublicPath } from "@/api/servicePaths";

import FETCHRAW from "../../fetchRaw";

export const refreshDashboardStats = async (): Promise<any> => {
  return FETCHRAW({
    type: "apiurl",
    path: backendPublicPath("/dashboard/refresh/"),
    method: "GET"
  });
};
